import Api from './rest/SpecChatMessageApi';

export default new Api();
